import { useState } from "react";
import axios from "axios";
import { FaCheckCircle } from "react-icons/fa";

interface FormEmailProps {
  blob: Blob;
}

const FormEmail: React.FC<FormEmailProps> = ({ blob }) => {
  const [email, setEmail] = useState("");
  const [errMessage, setErrMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const submitForm = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    const bodyFormData = new FormData();
    bodyFormData.append("contact_email", email);
    bodyFormData.append("the_file", blob, "myboat.pdf");
    axios({
      method: "post",
      url: "http://localhost/wp-json/boat-builder/v1/email",
      data: bodyFormData,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then(function (response) {
        setLoading(false);
        const { data } = response;
        if (data.status !== 200) {
          setErrMessage(data.message);
        } else {
          setErrMessage("");
          setSuccess(true);
        }
      })
      .catch(function (response) {
        setLoading(false);
        setErrMessage("There was some unknown Error, Please try again.");
      });
  };
  return (
    <>
      <div className={success ? "form-success active" : "form-success"}>
        <div>
          <div className="icon-container">
            <FaCheckCircle />
          </div>
          <h2 className="message">Success! Email Sent.</h2>
        </div>
      </div>
      <div className={loading ? "loader active" : "loader"}></div>
      <form className="formEmail" onSubmit={submitForm}>
        {errMessage ? (
          <div className="form-error">{errMessage}</div>
        ) : (
          <div></div>
        )}
        <div className="form-container">
          <div className="form-input-container">
            <label htmlFor="email">Email:</label>
            <input
              name="email"
              type="email"
              onChange={(e) => setEmail(e.target.value)}
              value={email}
            />
          </div>
        </div>
        <input type="submit" value="Send" />
      </form>
    </>
  );
};

export default FormEmail;
